/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_SingInputs */

const fr_rapid_eager_otter_sing = /** @type {(inputs: Rapid_Eager_Otter_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre abonnement restera actif jusqu'à la fin de la période en cours, puis ne sera plus renouvelé.`)
};

/**

* @param {Rapid_Eager_Otter_SingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_sing = /** @type {((inputs?: Rapid_Eager_Otter_SingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_SingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_sing(inputs)
});